import React from 'react';
import { Feature } from '@tencent/workbench';
import { config } from './config';
import BaseSelectablePanelFeature from '@framework/workbench/common/feature/base-selectable-panel-feature';
import SelectablePanel from '@framework/workbench/common/components/selectable-panel';
import { ConnectorFastStyleConfigs, IShapeStyles, ShapeFastStyleConfigs } from './fast-style-config';
import { transaction } from '@src/slide/domain/slide-app';
import { getAllChildModels } from '@src/slide/domain/ui-model/element-modeles/property/utils/merge-property';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import ShapeFastStyleCard from '@src/framework/workbench/common/components/selectable-panel/shape-fast-style-card';
import Styles from './index.less';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import { isShapeOrConnector } from '@src/slide/domain/ui-model/elements/element-judge';
import ConnectorFastStyleCard from '@src/framework/workbench/common/components/selectable-panel/connector-fast-style-card';

// Panel中展示的个数
const PANEL_COL_NUM = 7;

@Feature()
export class ShapeFastStyleFeature extends BaseSelectablePanelFeature {
    public id = config.id;
    public config = config;
    public constructor() {
        super();
    }

    public getContent() {
        const model = this.getSelectModel();
        const elementType = model?.type;
        return <div className={Styles['shape-fast-style']}>
            <SelectablePanel
                colNumber={PANEL_COL_NUM}
                showArrow={true}
                expandHeight={this.isLine(model) ? 260 : 360}
                childrenElements={
                    [
                        {
                            cardList: this.isLine(model)
                                ? ConnectorFastStyleConfigs.map((item, index) => ({
                                    element: <ConnectorFastStyleCard
                                        text={item.title}
                                        key={index}
                                        onClick={this.handleCardClick}
                                        shapeStyles={item}
                                        slideModel={
                                            this.getAppService().viewableServiceLayer.selectionService.currentSlide!
                                        }
                                    />,
                                    id: String(index),
                                })) : ShapeFastStyleConfigs.map((item, index) => ({
                                    element: <ShapeFastStyleCard
                                        text={item.title}
                                        key={index}
                                        onClick={this.handleCardClick}
                                        shapeStyles={item}
                                        slideModel={
                                            this.getAppService().viewableServiceLayer.selectionService.currentSlide!
                                        }
                                    />,
                                    id: String(index),
                                })),
                        },
                    ]
                } />
        </div>;
    }

    public shouldDisabled() {
        const model = this.getSelectModel() as IElementBaseModel;
        const models = getAllChildModels(model);
        return !models.filter(isShapeOrConnector).length;
    }

    private isLine(model) {
        return model.type === UIModelType.CONNECTOR || model.canSetArrowStyle?.();
    }

    private handleCardClick = (shapeStyles: IShapeStyles) => {
        const model = this.getSelectionService().getSelectedModel() as IElementBaseModel;
        const selectedModels = getAllChildModels(model);
        transaction(() => {
            selectedModels.forEach((model) => {
                if (model.type === UIModelType.SHAPE || model.type === UIModelType.CONNECTOR) {
                    (model as IShapeModel).resetStyle();
                    (model as IShapeModel).updateShapeFastStyle(null);
                    (model as IShapeModel).updateShapeFastStyle(shapeStyles.fastStyle);
                    if (shapeStyles.style) {
                        (model as IShapeModel).updateProps({ style: shapeStyles.style });
                    }
                }
            });
        });
    };
}
